module.exports = __webpack_public_path__ + "img/public/SiteIcons/homeSearchIcon.svg?8d1ab2a3";